import { createActions } from 'redux-actions';

export const {
  updateFilterFieldsOffers,
  searchOffers,
  changeTypeListOffers,
  countFiltersOffers,
  resetFiltersOffers,
} = createActions(
  'UPDATE_FILTER_FIELDS_OFFERS',
  'SEARCH_OFFERS',
  'CHANGE_TYPE_LIST_OFFERS',
  'COUNT_FILTERS_OFFERS',
  'RESET_FILTERS_OFFERS'
);
